import { useEffect, useState } from "react";
import Card from "../../../../components/Card/Card";
import List from "../../../../components/List/List";
import Pagination from "../../../../components/Pagination/Pagination";
import { useAuth } from "../../../../contexts/auth";
import "./ListRoles.css";
import RoleService from "../../../../services/RolesService";

const ListRoles = (props) => {
	const [roles, setRoles] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "updated_at",
		orderDirection: "DESC",
	});
	const { user } = useAuth();
	const [isLoading, setIsLoading] = useState(true);

	const clientData = user.userData.selectedOrganizationId ?? 1;

	const getRoles = async (page, searchText, clientID, orderBy) => {
		setIsLoading(true);
		try {
			const response = await RoleService.getPaginated(
				page,
				searchText,
				clientID,
				orderBy
			);
			if (response && response.data) {
				const paginated = response.data;
				setRoles(paginated.items);
				setMaxPage(paginated.pagination.totalPages);
			}
		} catch (error) {
			console.error(error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getRoles(1, props.filters, clientData.id, collumnClicked);
	}, [user, props.filters, collumnClicked, clientData.id, props.refreshKey]);

	return (
		<>
			<div className="list-container list-visibility ">
				<List
					isLoading={isLoading}
					lineSelected={props.lineSelected}
					handleCollumnTitleClick={(col) => setCollumnClicked(col)}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{
							collumnLabel: "Políticas", type: "text", custom: ({ row }) => {
								return (row.policies && row.policies.length > 0) ? row.policies.length : <span style={{ opacity: 0.36 }}>Não consta</span>;
							}
						},
						{ collumnLabel: "Criado em", index: "organizationName", type: "text" },
					]}
					data={roles?.map((role) => ({
						...role,
					}))}
				/>
			</div>
			<div className="card-visibility">
				{roles?.map((role, index) => (
					<Card
						key={role.id || index}
						data={role}
						delete={() => { }}
						navigateOnDelete={""}
						navigateOnEdit={""}
					>
						<p className="card-content-title">{role.name}</p>
					</Card>
				))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					getRoles(page, props.filters, clientData.id, collumnClicked)
				}
			/>
		</>
	);
};

export default ListRoles;
